
    (function () {
      const sliders = document.querySelectorAll('.testimonial-slider');

      sliders.forEach((slider) => {
        const container = slider.querySelector('.slider-container');
        const slides = slider.querySelectorAll('.slide');
        const prev = slider.querySelector('.prev');
        const next = slider.querySelector('.next');

        let index = 0;
        let isAnimating = false;
        let userInteracted = false; //NEW FLAG

        function stopAllVideos() {
          slider.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.currentTime = 0;
          });
        }

        function playActiveVideo() {
          if (!userInteracted) return; //PREVENT AUTO PLAY

          const video = slides[index].querySelector('video');
          if (video) {
            video.play().catch(() => {});
          }
        }

        function update() {
          if (isAnimating) return;
          isAnimating = true;

          stopAllVideos();
          container.style.transform = `translate3d(-${index * 100}%, 0, 0)`;

          prev.classList.toggle('disabled', index === 0);
          next.classList.toggle('disabled', index === slides.length - 1);

          setTimeout(() => {
            playActiveVideo();
            isAnimating = false;
          }, 0);
        }

        prev.addEventListener('click', () => {
          if (index > 0) {
            userInteracted = true; //SET ON USER ACTION
            index--;
            update();
          }
        });

        next.addEventListener('click', () => {
          if (index < slides.length - 1) {
            userInteracted = true; //SET ON USER ACTION
            index++;
            update();
          }
        });

        // Initial render — NO video autoplay
        update();
      });
    })();
